<h1 mat-dialog-title
    class="draggable-dialogue-header"
    cdkDrag
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDragHandle>
    Publish Document
</h1>

<div mat-dialog-content>
    <mat-form-field appearance="fill">
        <mat-label>Choose a Document</mat-label>
        <mat-select #exportSelect (selectionChange)="onSelectionChange($event.value)">
            <mat-option *ngFor="let es of Settings" [value]="es"><i class="file-icon" [appIcon]="es"></i> {{es.name}}</mat-option>
        </mat-select>
    </mat-form-field>

    <div class="execution-time-div">
        <span>Execution Time: </span>
        <span [ngClass]="this.JobInProgress ? 'active-execution-time-span' : 'idle-execution-time-span'">{{this.JobTimeElapsed}}</span>
    </div>

    <div class="execution-status-div">
        <span>Execution Status: </span>
        <span [ngClass]="this.JobCompleted ? 'completed-execution-status-span' : 'incomplete-execution-status-span'">{{this.JobStatus}}</span>
    </div>

    <div #executionSummary class="execution-summary-div">
        <p [ngClass]="this.JobErrorOccurred ? 'execution-summary-p execution-summary-with-error-p' : 'execution-summary-p execution-summary-without-error-p'"
           data-placeholder="Details will display here ..."
           [innerHTML]="this.ExecutionSummaryText ? (this.ExecutionSummaryText | safe: 'html') : null ">
        </p>
    </div>

</div>

<div mat-dialog-actions>
    <button mat-flat-button color="primary" class="theme-primary-btn" (click)="startPublishJob()" [disabled]="ReadyToPublish">Publish</button>
    <ng-container>
        <div *ngIf="this.SelectedDocument == this.OUTPUT_TYPE_EMAIL; else docPublishing">
            <button *ngIf="this.PublishedDocUrl != null" mat-flat-button [mat-dialog-close]="null" style="margin-left: 10px;">Done</button>
        </div>
        <ng-template #docPublishing>
            <a *ngIf="this.PublishedDocUrl != null" href="{{this.PublishedDocUrl}}" target="_blank" class="download">Download</a>
            <!--<span *ngIf="this.PublishedDocUrl == null" class="download">Download</span>-->
        </ng-template>
    </ng-container>
    <button mat-flat-button [mat-dialog-close]="null" style="margin-left: 10px;">Cancel</button>
</div>
